<template>
  <div id="international" v-show="showInternational" class="internationalstudy" ref="international">
    <div class="internationalstudy-title">
      <h2>{{ title }}</h2>
      <div class="title-items">
        <ul>
          <li
            :class="{active: currentCountry === country.countryName}"
            :key="country.countryId"
            v-for="country in countryCodeArr"
            @click="checkItem(country.countryName)"
          >{{ country.countryName }}</li>
        </ul>
      </div>
    </div>
    <div
      class="internationalstudy-content"
      v-for="countryData in countryDataArr"
      :key="countryData.countryName"
      v-show="currentCountry === countryData.countryName"
    >
      <loading v-if="loadingFlag"></loading>
      <div
        class="internationalstudy-content-item"
        v-for="(yxData, index) in countryData.countryData"
        :key="index"
        @mouseenter="maskShow(index)"
        @mouseleave="maskHide(index)"
      >
        <div class="item-img">
          <img :src="yxData.img_original">
        </div>
        <div class="item-content">
          <a :title="yxData.name" :href="yxData.url" :class="yxData.name.length>16?'':'single'">{{ yxData.name }}</a>
          <p>招生对象：<span class="Enrollment_target">{{ yxData.admission_object }}</span></p>
          <p>截止时间：<span class="endtime">{{ yxData.end_sign_day }}</span></p>
          <p>订金：<span class="price">{{ yxData.market_price }}</span></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import jsonp from 'js/jsonp.js'
import Loading from '@/common-components/Loading'
export default {
  name: 'Noiteminternationalstudy',
  components: {
    Loading
  },
  props: ['title'],
  data () {
    return {
      loadingFlag: false,
      currentCountry: null,
      maskFlag: -1,
      showInternational: true,
      yxCountry: [{
        countryId: 1,
        countryName: '美国'
      },
      {
        countryId: 2,
        countryName: '加拿大'
      },
      {
        countryId: 3,
        countryName: '澳洲'
      },
      {
        countryId: 4,
        countryName: '英国'
      },
      {
        countryId: 6,
        countryName: '新西兰'
      },
      {
        countryId: 7,
        countryName: '亚洲'
      },
      {
        countryId: 8,
        countryName: '欧洲'
      }],
      countryCodeArr: [],
      countryDataArr: []
    }
  },
  computed: {
  },
  mounted () {
    this.getYxData(this.yxCountry, 0)
  },
  methods: {
    getYxData (yxCountry, index) {
      let _this = this
      if (index === yxCountry.length) {
        return
      }
      jsonp('http://youxue.xdf.cn/api/getcatlist.php', {
        cat_id: yxCountry[index].countryId
      }).then(function (res) {
        if (res[0].LIST.length >= 5) {
          res[0].LIST.length = 5
          if (_this.currentCountry === null) {
            _this.currentCountry = yxCountry[index].countryName
          }
          _this.countryCodeArr.push(yxCountry[index])
          _this.countryDataArr.push({
            countryName: yxCountry[index].countryName,
            countryData: res[0].LIST
          })
        }
        index += 1
        _this.getYxData(yxCountry, index)
      }).catch(function (error) {
        if (error.message === 'Timeout') {
          _this.showInternational = false
        }
        // index += 1
        // _this.getYxData(yxCountry, index)
      })
    },
    checkItem (country) {
      this.currentCountry = country
    },
    maskShow (index) {
      this.maskFlag = index
    },
    maskHide (index) {
      this.maskFlag = -1
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl'
@import '~styles/mixins.styl'
.active
  border-left: 1px solid #c0e1a5
  border-right: 1px solid #c0e1a5
  border-top: 2px solid #62b31f
  background: #fff
  color: #62b31f
.internationalstudy
  width: 1200px
  height: 320px
  margin: 18px auto
  display: flex
  flex-direction: column
  .internationalstudy-title
    height: 40px
    line-height: 40px
    padding-left: 16px
    background-color: #f3f3f3
    border-bottom: 2px solid #c0e1a5
    display: flex
    h2
      font-size: 18px
      flex: 1
      width:236px
      float:left
    .title-items
      flex: 4
      li
        padding: 0 20px
        font-size: 16px
        float: $fl
        cursor: pointer
        position: relative
        top: -2px
        height: 42px
  .internationalstudy-content
    flex: 1
    display: flex
    margin-top: 10px
    justify-content: space-between
    .internationalstudy-content-item
      width: 228px
      height: 254px
      font-size: 12px
      display: flex
      position: $rel
      flex-direction: column
      line-height: 20px
      float: left
      margin-right: 12px
      .item-img
        height: 132px
        position: $rel
        img
          width: 100%
          height: 100%
      .item-content
        flex: 2
        a
          line-height: 20px
          height: 40px
          font-size: 13px
          color: #3f3f3f
          max-height: 60px
          overflow: hidden
          display: block
          margin: 8px 0
          &:hover
            color: $themeColor
        .single
           line-height: 40px
        p
          line-height: 22px
          color: #aeaeae
        .price
          font-size: 14px
          color: #ff7011
          font-weight: bold
</style>



// WEBPACK FOOTER //
// src/pages/middleschool/components/Internationalstudy.vue